<template>
  <div class="list-table-file-type">
    {{ util.ordinaryFileTypeMap[scope.row.fileType] }}
  </div>
</template>

<script>
export default {
  name: 'ListTableFileType',
  props: {
    scope: {
      type: Object,
      default () {
        return {}
      }
    }
  }
}
</script>
